var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6e7d94;}.b{clip-path:url(#a);}.c{fill:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 84,
    height: 84,
    transform: "translate(592 5107)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-592 -5107)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(592 5107)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H84V84H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M67.725,35.14a26.224,26.224,0,0,0-49-7A20.991,20.991,0,0,0,21,70H66.5a17.45,17.45,0,0,0,1.225-34.86ZM66.5,63H21a14,14,0,0,1,0-28h2.485A19.247,19.247,0,0,1,61.25,40.25V42H66.5a10.5,10.5,0,0,1,0,21Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.0ba5eb40939d30260034b8fcaa515656.svg";
export { ForwardRef as ReactComponent };